import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CausaRaizService {
  private apiUrl = `${environment.apiUrl}/causas-raiz`;

  constructor(private http: HttpClient) { }

  getCausasRaizPaginado(
    page: number, 
    limit: number, 
    sortBy: string, 
    sortOrder: string, 
    search: string
  ): Observable<{ data: any[], total: number }> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('search', search);

    return this.http.get<{ data: any[], total: number }>(this.apiUrl, { params });
  }

  getCausasRaizParaExportar(
    sortBy: string, 
    sortOrder: string, 
    search: string
  ): Observable<{ data: any[] }> {
    let params = new HttpParams()
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('search', search)
      .set('export', 'true');
      
    return this.http.get<{ data: any[] }>(this.apiUrl, { params });
  }
  
  eliminarCausaRaiz(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  findAll(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`);
  }

  findOne(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, data);
  }

  update(id: number, data: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
} 